var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',{attrs:{"enable-footer":false}},[_c('VContainer',{attrs:{"fluid":"","fill-height":""}},[_c('ConfirmPayment')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }